import {
  FETCH_STORE_MENU,
  FETCH_STORE_MENU_SUCCESS,
  FETCH_STORE_MENU_FAILURE,
  FETCH_MENU_COLUMNS_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  storeMenu: [],
  menuContent: [],
  loading: false,
  error: null,
}

const storeMenuReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_STORE_MENU:
      return { ...state, loading: true, error: null };
    case FETCH_STORE_MENU_SUCCESS:
      return { ...state, storeMenu: action.payload, loading: false };
    case FETCH_MENU_COLUMNS_SUCCESS:
      return { ...state, menuContent: action.payload };
    case FETCH_STORE_MENU_FAILURE:
    default:
      return state;
  }
};

export default storeMenuReducer;




